export default {
    addonsTitle: 'Add-ons',
    addonsMenu: 'Add-ons',
    newAddon: 'New add-on',
    editAddon: 'Edit add-on',
    createAddon: 'Create add-on',
    addonName: 'Add-on name',
    addonModule: 'Module',
    addonAttribute: 'Expandable attribute',
    addonUnitValue: 'Increment per unit',
    addonPricePerUnit: 'Price per unit',
    addonCurrency: 'Currency',
    addonActive: 'Active',
    addonNameEs: 'Name (Spanish)',
    addonNameEn: 'Name (English)',
    selectModule: 'Select a module',
    selectAttribute: 'Select an attribute',
    noEligibleAttributes: 'This module has no add-on eligible attributes',
    addonCreated: 'Add-on created successfully',
    addonUpdated: 'Add-on updated successfully',
    addonStatusUpdated: 'Add-on status updated',
    addonCreateError: 'Error creating the add-on',
    addonUpdateError: 'Error updating the add-on',
    addonLoadError: 'Error loading the add-ons',
    addonStatusError: 'Error changing the add-on status',
    confirmToggleAddon: 'Do you want to change this add-on status?',
    confirmDeleteAddon: 'Are you sure you want to delete this add-on? This action cannot be undone.',
    addonDeleted: 'Add-on deleted successfully',
    addonDeleteError: 'Error deleting the add-on',
    attributeImmutableHint: 'The attribute cannot be changed after the add-on is created',
    tableId: 'ID',
    tableStatus: 'Status',
    tableActions: 'Actions',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    backToList: 'Back',
    save: 'Save',
    cancel: 'Cancel',
    enableEdit: 'Enable editing',
    enableEditFirst: 'You need to enable editing first',
    validationNameEsRequired: 'The Spanish name is required',
    validationNameEnRequired: 'The English name is required',
    validationUnitValueRequired: 'The increment is required',
    validationUnitValueNumber: 'The increment must be a number',
    validationUnitValueMin: 'The increment must be at least 1',
    validationPriceRequired: 'The price is required',
    validationPriceNumber: 'The price must be a number',
    validationPriceMin: 'The price cannot be negative',
    validationCurrencyRequired: 'The currency is required',
};
